<div [formGroup]="fg">
    <div class="action-setting">
        <div class="action-setting-title">
            {{ "commonActions.sendWebhookAction.url" | labelsProvider }}
        </div>
        <input
            class="action-setting-input"
            formControlName="url"
            type="text"
            placeholder="Enter a url"
            [ngClass]="{
                'input-form-invalid': fg.controls['url'].invalid && (fg.controls['url'].dirty || fg.controls['url'].touched),
            }" />
    </div>
    <div class="action-setting">
        <div class="action-setting-title">
            {{ "commonActions.sendWebhookAction.token" | labelsProvider }}
        </div>
        <input
            class="action-setting-input"
            formControlName="token"
            type="password"
            placeholder="Enter a secret (Optional)"
            [ngClass]="{
                'input-form-invalid': fg.controls['token'].invalid && (fg.controls['token'].dirty || fg.controls['token'].touched),
            }" />
    </div>
</div>
